import {Link, useNavigate} from "react-router-dom";

import logo from "../../assets/logo.png"
import {useEffect, useRef, useState} from "react";

import sdk from "scoutli-sdk"

const _GetStarted = () => {
    const name = useRef("")
    const email = useRef("")
    const password = useRef("")
    const passwordAgain = useRef("")

    const [error, setError] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {
        if (localStorage.getItem("accessToken")){
            return navigate("/")
        }
    })

    return (
        <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <Link to="/">
                    <img
                        className="mx-auto h-12 w-auto"
                        src={logo}
                        alt="Scoutli"
                    />
                </Link>

                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Create new account</h2>

                <p className="mt-2 text-center text-sm text-gray-600">
                    Or{' '}
                    <Link to="/login" className="font-medium text-indigo-600 hover:text-indigo-500">
                        log in to your account
                    </Link>
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 sm:rounded-lg sm:px-10">
                    <form className="space-y-6" action="#" method="POST" onSubmit={event => {
                        event.preventDefault()

                        sdk.auth.signup(name.current.value, email.current.value, password.current.value, passwordAgain.current.value).then(response => {
                            localStorage.setItem("accessToken", response.accessToken)

                            navigate("/")

                            window.location.reload()
                        }).catch(_error => {
                            setError(_error.en)
                        })
                    }}>
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                Name and Surname
                            </label>

                            <div className="mt-1">
                                <input
                                    ref={name}
                                    id="name"
                                    name="name"
                                    type="text"
                                    autoComplete="name"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 transition-colors rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email address
                            </label>

                            <div className="mt-1">
                                <input
                                    ref={email}
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 transition-colors rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                Password
                            </label>

                            <div className="mt-1">
                                <input
                                    ref={password}
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete="current-password"
                                    placeholder="********"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="password-again" className="block text-sm font-medium text-gray-700">
                                Password again
                            </label>

                            <div className="mt-1">
                                <input
                                    ref={passwordAgain}
                                    id="password-again"
                                    name="password-again"
                                    type="password"
                                    autoComplete="current-password"
                                    placeholder="********"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        {error !== null && (
                            <p className="mt-2 text-red-400 text-sm">{error}</p>
                        )}

                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-white bg-brand transition-colors hover:bg-indigo-600"
                            >
                                Get started
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default _GetStarted;
